export const TherapyTemplateItemEnum = {
  SYMPTOM: "SYMPTOM",
  TYPE: "TYPE",
  CATEGORY: "CATEGORY",
  PATHOGEN: "PATHOGEN",
};
